import { TableBody } from "@mui/material";
import { GridColDef, RowType } from "./AppTable";
import AppTableRow from "./AppTableRow";

type AppTableBodyProps<T> = {
  data: T[];
  columns: GridColDef<T>[];
  selectedList: string[];
  onSelectRow: (id: string) => void;
  hasCheckbox: boolean;
};

function AppTableBody<T extends RowType>(props: AppTableBodyProps<T>) {
  const { data, columns, selectedList, onSelectRow, hasCheckbox } = props;

  return (
    <TableBody>
      {data.map((row: T) => (
        <AppTableRow
          key={row.uid}
          columns={columns}
          row={row}
          selectedList={selectedList}
          onSelectRow={onSelectRow}
          hasCheckbox={hasCheckbox}
        />
      ))}
    </TableBody>
  );
}

export default AppTableBody;
